/** @format */

import { useCallback, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setDashboard } from "redux/actions/dashboardAction";
import { getDashboardAll } from "services/v2/notificationservice";

const CACHE_TTL = 30 * 60 * 1000;

export const useDashboardIndikatif = (auth: any) => {
  const dispatch = useDispatch();

  const { indikatifHeader1, indikatifHeader2, cacheTime } = useSelector(
    (state: any) => ({
      indikatifHeader1: state.dashboard?.indikatifHeader1 || {},
      indikatifHeader2: state.dashboard?.indikatifHeader2 || [],
      cacheTime: state.dashboard?.cacheTime || {},
    }),
    shallowEqual,
  );

  const [loading, setLoading] = useState(false);
  const [dataDetail, setDataDetail] = useState([]);
  const fetchData = useCallback(
    async (force: boolean = false, filter: any = {}) => {
      if (!auth?.isTahun) return;

      const now = Date.now();
      const lastFetch = cacheTime?.dashboard;

      /** gunakan cache jika masih valid */
      if (
        !force &&
        Object.keys(indikatifHeader1).length > 0 &&
        indikatifHeader2.length &&
        lastFetch &&
        now - lastFetch < CACHE_TTL
      ) {
        return;
      }

      setLoading(true);

      try {
        let params = {
          tahun: auth?.isTahun,
          ...filter,
        };

        if (auth?.group_role !== "pusat") {
          params["kodeProvinsi"] = auth?.kode_provinsi;
        }

        if (!["pusat", "provinsi"].includes(auth?.group_role)) {
          params["kodeKabKota"] = auth?.kode_kabkota;
        }

        if (auth?.group_role === "madrasah") {
          params["nsm"] = auth?.madrasah?.nsm;
        }

        const [dashboard1, dashboard2] = await Promise.all([
          getDashboardAll("dashboard/indikatif-header-1", params),
          getDashboardAll("dashboard/indikatif-header-2", params),
        ]);

        /** filter provinsi jika bukan admin pusat */
        // if (auth?.kode_role !== "admin_pusat_bos") {
        //   result = result.filter(
        //     (item: any) => item.kodeProvinsi === auth?.kode_provinsi,
        //   );
        // }

        dispatch(
          setDashboard({
            indikatifHeader1: dashboard1 || {},
            indikatifHeader2: dashboard2 || [],

            cacheTime: {
              ...cacheTime,
              dashboard: Date.now(),
            },
          }),
        );
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      auth?.isTahun,
      auth?.kode_role,
      auth?.kode_provinsi,
      cacheTime?.dashboard,
      dispatch,
    ],
  );

  const getDataDetail = useCallback(
    async (link: string, payload: any) => {
      setLoading(true);

      try {
        let params: any = {
          tahun: auth?.isTahun,
          ...payload,
        };

        if (auth?.group_role !== "pusat") {
          params.kodeProvinsi = auth?.kode_provinsi;
        }

        if (!["pusat", "provinsi"].includes(auth?.group_role)) {
          params.kodeKabKota = auth?.kode_kabkota;
        }

        const result = await getDashboardAll(`dashboard/${link}`, params);

        setDataDetail(result || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [auth?.isTahun, auth?.group_role, auth?.kode_provinsi, auth?.kode_kabkota],
  );
  /**
   * fetch ketika tahun berubah
   */

  return {
    loading,
    indikatifHeader1,
    indikatifHeader2,
    dataDetail,
    getDataDetail,
    fetchData,
    cacheTime,
  };
};
